// @flow

import {
  DraftLiveStateEnum,
  ABSENCE_REASON_TYPES,
  ABSENCE_REASON_STATE,
} from "@modules/service/constants";
import type { AbsenceReasonsState } from "./types";

export const initialState: AbsenceReasonsState = {
  requestsInProgress: 0,
  list: null,
  activeList: null,
  pendingList: null,
  draftList: null,
  schema: null,
  current: null,
  draft: null,
  assignments: [],
  configuration: {
    enabled: true,
    status: DraftLiveStateEnum.LIVE,
  },
  modals: {
    showAddAbsenceReasonModal: false,
    modalStep: 1,
    showEditModal: false,
    showSubmitModal: false,
    showCancelModal: false,
    showDiscardModal: false,
    showCancelDiscardModal: false,
    showDisableModal: false,
  },
  filterState: ABSENCE_REASON_STATE.ALL,
  filterType: ABSENCE_REASON_TYPES.ALL,
};

export default initialState;
